import sharingFields from './sharing-fields';
import sharingNetworks from './sharing-networks';

const sharingNetworkFields = {
  [sharingNetworks.DEFAULT]:   sharingFields.ALL,
  [sharingNetworks.TWITTER]:   [sharingFields.MESSAGE],
  [sharingNetworks.PINTEREST]: [sharingFields.MESSAGE, sharingFields.PICTURE],
  [sharingNetworks.FACEBOOK]:  [sharingFields.TITLE, sharingFields.MESSAGE, sharingFields.PICTURE],
  [sharingNetworks.WHATSAPP]:  [sharingFields.MESSAGE],
};

export default sharingNetworkFields;
